import { render, staticRenderFns } from "./authorBuild.vue?vue&type=template&id=0a502d98&scoped=true"
import script from "./authorBuild.vue?vue&type=script&lang=js"
export * from "./authorBuild.vue?vue&type=script&lang=js"
import style0 from "./authorBuild.vue?vue&type=style&index=0&id=0a502d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a502d98",
  null
  
)

export default component.exports